import get from 'lodash/get';
import * as types from './constants';

const initialState = {
  loading: false,
  error: null,
  isNonUAE: false,
  slugName: '',
};

export default function serviceReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.FETCH_SERVICES:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_SERVICES_SUCCESS:
      return {
        ...state,
        loading: false,
        isNonUAE: false,
      };
    case types.FETCH_SERVICES_ERROR:
      return {
        ...state,
        loading: false,
        error: get(action.payload, 'error', 'Oops! Something went wrong'),
        isNonUAE: false,
      };
    case types.NON_UAE_VALIDATION_ERROR:
      return {
        ...state,
        isNonUAE: true,
        error: action.payload,
      };
    case types.SAVE_SLUG_NAME:
      return {
        ...state,
        slugName: action.payload,
      };
    default:
      return state;
  }
}
